import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from "@angular/core";
import { throwErrorMessage } from "../../../../helpers/kwikui.common.helpers";
import { DEFAULT_VALUES, VALIDATE_KEY_VALUES } from "./lottie.constants";
import { isValidKeyValue } from "./lottie.validation";

@Component({
  selector: "kwikui-animation-player-lottie",
  templateUrl: "./lottie.component.html",
  styleUrls: ["./lottie.component.scss"]
})
export class KwikUIAnimationPlayerLottieComponent implements OnInit, OnChanges {
  @Input() config: string = DEFAULT_VALUES.config;

  @Input() id: string = DEFAULT_VALUES.id;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    const verifyChange = (key: string) => {
      return changes.hasOwnProperty(key) && !changes[key].firstChange;
    };

    for (const change of Object.entries(changes)) {
      const key: string = change[0];
      const value: any = change[1].currentValue;

      this.validateInputProperty(key, value);
    }

    if (verifyChange("config")) {
      this.config = changes.config.currentValue;
    }
  }

  ngOnDestroy(): void {}

  private validateInputProperty(key: string, value: any): void {
    if (VALIDATE_KEY_VALUES[key] && !isValidKeyValue(key, value)) {
      this[key] = DEFAULT_VALUES[key];
      throwErrorMessage(
        "kwikui-animation-player-lottie",
        this.id,
        key,
        value,
        DEFAULT_VALUES[key]
      );
    }
  }

  handleAnimationCreated(e: any) {}

  handleConfigReady() {}

  handleDataReady() {}

  handleDomLoaded() {}

  handleEnterFrame(e: any) {}

  handleSegmentStart(e: any) {}

  handleComplete(e: any) {}

  handleLoopComplete(e: any) {}

  handleDestroy(e: any) {}

  handleError(e: any) {}
}
